// removed by extract-text-webpack-plugin
module.exports = {"price":"c-Price__price","total":"c-Price__total","quantity":"c-Price__quantity","value":"c-Price__value","beforeDiscount":"c-Price__beforeDiscount","discounted":"c-Price__discounted"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/Price/Price.scss
// module id = 456
// module chunks = 0